const getApiBaseUrl = () => {
  const env = (process.env.REACT_APP_IS_PROD || "").toUpperCase();
  if (env === "DEV") {
    return process.env.REACT_APP_SERVER_DEV || "https://localhost:44390";
  }
  if (env === "TRUE" || env === "PROD") {
    return process.env.REACT_APP_SERVER_PROD;
  }
  return process.env.REACT_APP_SERVER_TEST;
};

export default getApiBaseUrl;
